<template>
  <div class="slider_module">
    <swiper :options="options" ref="mySwiper">
      <swiper-slide :key="index" :class="id + '_' + index" v-for="(slider, index) in sliders"></swiper-slide>
    </swiper>
  </div>
</template>
<script>
import Vue from 'vue';
export default {
  name: "sliderModule",
  props: {
    modules: {
      type: Array,
      required: true
    },
    activeIndex: {
      type: Number,
      default: 0
    },
    options: {
      type: Object,
      default() {
        return {}
      }
    },
    mySwiper: {},
    loader: {},
    updateData: {}
  },
  data() {
    let sliders = [];
    this.modules.forEach((item, index) => {
      sliders.push({
        module: item,
        loaded: false
      });
    });
    return {
      id: `swiper_${Math.round(Math.random() * 1e10)}`,
      sliders: sliders,
    }
  },
  created() { },
  mounted() {
    this.loadComponent(this.activeIndex);
    this.watchIndex();
    this.$emit("update:mySwiper", this.$refs.mySwiper.swiper);
  },
  methods: {
    /**
     * [watchIndex description] 监控滑动事件
     * @return {[type]} [description]
     */
    watchIndex() {
      let self = this;
      this.swiper.on("slideChange", () => {
        this.loadComponent(this.swiper.activeIndex);
        if (this.swiper.activeIndex != this.activeIndex) {
          this.$emit("slideChange", this.swiper.activeIndex);
        }
        this.$emit("update:activeIndex", this.swiper.activeIndex)
      })
    },
    /**
     * [loadComponent description] 动态加载组件
     * @return {[type]} [description]
     */
    loadComponent(index) {
      if (this.swiper.activeIndex !== index) {
        this.swiper.slideTo(index);
      }
      let slider = this.sliders[index];
      if (slider.loaded) {
        this.$emit("update:updateData", slider.updateData);
        return;
      }
      slider.loaded = true;
      slider.module.beforeLoadModule = typeof slider.module.beforeLoadModule == 'function' ? slider.module.beforeLoadModule : () => {
        return new Promise((resolve, reject) => {
          resolve();
        });
      }
      let loader = slider.module.beforeLoadModule().then(resp => {
        slider.updateData = resp;
        this.$emit("update:updateData", resp);
        return slider.module.moduleFn();
      }).then(resp => {
        let $el = $(this.$el);
        let component = resp.default;
        component = Vue.extend(component);
        let $div = $(document.createElement('div'));
        $div.css({
          width: '100%',
          height: '100%'
        });
        $el.find(`.${this.id}_${index}`).html($div);
        new component({
          el: $div[0],
          propsData: slider.module.props,
          parent: this
        });
      });
      this.$emit("update:loader", loader);
    },
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper;
    }
  },
  watch: {
    activeIndex(newV, oldV) {
      if (newV == oldV) return;
      this.loadComponent(newV);
    }
  }
}
</script>
<style scoped lang='less'>
.slider_module {
  width: 100%;
  height: 100%;

  .swiper-container {
    height: 100%;
  }
}
</style>